(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bw-interactions"] && !Shopify.designMode) return;
  try {
    (()=>{function init(root=document){root.querySelectorAll('[data-bw-tabs]').forEach(group=>{if(group.dataset.ready)return;group.dataset.ready='true';const tabs=[...group.querySelectorAll('[data-bw-tab]')];const activate=(t,focus=false)=>{tabs.forEach(b=>{b.setAttribute('aria-selected',b===t);b.tabIndex=b===t?0:-1});group.querySelectorAll('[data-bw-panel]').forEach(p=>p.hidden=p.dataset.bwPanel!==t.dataset.bwTab);if(focus)t.focus()};tabs.forEach((t,i)=>{t.onclick=()=>activate(t);t.onkeydown=e=>{let j;if(e.key==='ArrowRight')j=(i+1)%tabs.length;if(e.key==='ArrowLeft')j=(i-1+tabs.length)%tabs.length;if(e.key==='Home')j=0;if(e.key==='End')j=tabs.length-1;if(j!==undefined){e.preventDefault();activate(tabs[j],true)}}})})}init();document.addEventListener('shopify:section:load',e=>init(e.target));})();
  } catch(e) { console.error(e); }
})();

})();
